<template>
	<div id="LogisticsCenter" class="logisticsCenter">
		<div class="row justify-content-md-center mb-2">
			<div class="col col-lg-4">
				<input-search-intelligent-component
					:minCharsAnalyze="1"
					:analyzeAuto="true"
					_placeholder="Ingrese lo que andas buscando"
					_class="form-control form-control-sm text-center"
					@actionKeyUp="actionKeyUpLocal"
					@actionKeyEnter="actionKeyEnterLocal"
					@actionCommand="actionCommandLocal"
					ref="inputSearchIntelligentComponentGeneral">
				</input-search-intelligent-component>
    		</div>
		</div>
		<div v-show="true">
			<div class="card" v-show="existCurrentsAction('PRODUCT')">
				<div class="card-body">
					<product-component
						ref="productComponent"
						:id="searchId"
						:autoSearch="autoSearchProduct"
						:btnSave="true"
						@actionProductNotFound="actionProductNotFoundLocal"
						@actionSaveProduct="actionSaveProductLocal">
					</product-component>
				</div>
			</div>
			<div class="card" v-show="existCurrentsAction('LISTPRODUCT')">
				<div class="card-body">
					<list-products-component
						ref="listProductsComponent"
						:search="search"
						@actionGetAll="actionGetAllProductsLocal"
						@actionSelectItem="actionSelectItemProductLocal">
					</list-products-component>
				</div>
			</div>
			<div class="card" v-show="existCurrentsAction('SHIPPINGREQUEST')">
				<div class="card-body">
					<shipping-request-component
						ref="shippingRequestComponent"
						:id="searchId"
						@actionShippingRequestNotFound="actionShippingRequestNotFoundLocal">
					</shipping-request-component>
				</div>
			</div>
			<div class="card" v-show="existCurrentsAction('LISTSHIPPINGSREQUEST')">
				<div class="card-body">
					<list-shippings-request-component
						ref="listShippingsRequestComponent"
						:search="search"
						@actionGetAll="actionGetAllShippingsRequestLocal"
						@actionSelectItem="actionSelectItemShippingRequestLocal">
					</list-shippings-request-component>
				</div>
			</div>
			<div class="" v-show="existCurrentsAction('LISTSTORES')">
				<div class="">
					<stores-component
						ref="listStoresComponent"
						:enableActiveNewStore="true"
						:enableActiveNewStoreRack="true"
						:enableActiveNewStoreRackSide="true"
						:enableActiveNewStoreRackSideModule="true">
					</stores-component>
				</div>
			</div>

			<div class="" v-show="existCurrentsAction('PRINTERLEGALDOCUMENT')">
				<div>
					<printer-legal-document-component
						ref="printerLegalDocumentComponent"
						:typeLegalDocumentID="dataPrinterLegalDocumentComponent.typeLegalDocumentID"
						:legalDocumentNumber="dataPrinterLegalDocumentComponent.legalDocumentNumber"
						:quantity="dataPrinterLegalDocumentComponent.quantity">
					</printer-legal-document-component>
				</div>
			</div>

			<div class="" v-show="existCurrentsAction('STORERACKSIDEROWCOLUMN')">
				<div>
					<column-component
						ref="columnComponent"
						:id="searchId">
					</column-component>
				</div>
			</div>

			<div class="" v-show="existCurrentsAction('LISTMANIFESTOS')">
				<div>
					<list-manifestos-component
						:showManifestoLocal="true"
						ref="listManifestosComponent">
					</list-manifestos-component>
				</div>
			</div>
		</div>

		<!-- Modal Configuracíón Modulo -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#configModuleModal" ref="btnConfigModuleModal" v-show="false">Abrir Configuracíón Modulo</button>

		<!-- Modal -->
		<div class="modal fade" id="configModuleModal" tabindex="-1" aria-labelledby="configModuleModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
					<h6 class="modal-title" id="configModuleModalLabel">Configuración del Modulo</h6>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
					</div>
					<div class="modal-body">
					...
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import commands from '@/mixins/commands'

	import InputSearchIntelligentComponent from '@/components/InputSearchIntelligentComponent.vue'
	import ProductComponent from '@/components/ProductComponent.vue'
	import ListProductsComponent from '@/components/ListProductsComponent.vue'
	import ShippingRequestComponent from '@/components/ShippingRequestComponent.vue'
	import ListShippingsRequestComponent from '@/components/ListShippingsRequestComponent.vue'
	import StoresComponent from '@/components/StoresComponent.vue'
	import PrinterLegalDocumentComponent from '@/components/PrinterLegalDocumentComponent.vue'
	import ColumnComponent from '@/components/ColumnComponent.vue'
	import ListManifestosComponent from '@/components/ListManifestosComponent.vue'

	export default {
		name: 'LogisticsCenter',
		mixins: [axiosAction, errors, mixin, commands],
		data() {
			return {
				search: '',
				currentsAction: [],
				searchId: 0,
				autoSearchProduct: true,
				showCardLocal: false,
				dataPrinterLegalDocumentComponent: {
					typeLegalDocumentID: 0,
					legalDocumentNumber: '',
					quantity: 1
				}
			}
		},
		components: {
			'input-search-intelligent-component': InputSearchIntelligentComponent,
			'list-products-component': ListProductsComponent,
			'list-shippings-request-component': ListShippingsRequestComponent,
			'product-component': ProductComponent,
			'printer-legal-document-component': PrinterLegalDocumentComponent,
			'shipping-request-component': ShippingRequestComponent,
			'stores-component': StoresComponent,
			'column-component': ColumnComponent,
			'list-manifestos-component': ListManifestosComponent,
		},
		computed: {
		},
		methods: {
			initModuleLocal() {
				this.setTitleModule('Central Logistica')
				this.setSubTitleModule('')
				this.setInitModule()
				this.getCommandsByTypeLocal()
			},
			actionGetAllProductsLocal(data) {
			},
			actionGetAllShippingsRequestLocal(data) {
			},
			actionKeyUpLocal(data) {},
			actionKeyEnterLocal(data) {
				switch (this.currentAction) {
					default:
						this.analizeResultSearch(data)
						break
				}
			},
			actionProductNotFoundLocal(id) {
				this.removeCurrentsAction('PRODUCT')
				this.showCardLocal = false
				setTimeout(() => {
					if(confirm('El articulo ' + id + ' no está en la base de datos\n¿Desea crearlo ahora?')) {
						this.showProductLocal(id, false)
					}
				}, 300)
			},
			actionShippingRequestNotFoundLocal(id) {
				this.removeCurrentsAction('SHIPPINGREQUEST')
				this.$snotify.warning('No se encontró la solicitud de envío Nº ' + id, 'No encontrado')
			},
			actionCommandLocal(command) {
				if(command != null) {
					switch(command.id) {
						case 15:
							this.setInitModule()
							break
						case 17:
							this.showConfigModuleLocal()
							break
						case 19:
							this.showProductLocal(0)
							break
						case 21:
							this.showStoresLocal(command.search)
							break
						case 23:
							this.showPrinterLegalDocumentLocal(command.search)
							break
						case 24:
							this.showConfigGeneralLocal()
							break
						case 25:
							this.showManifestosLocal()
							break
						default:
							break
					}
					this.$refs.inputSearchIntelligentComponentGeneral.$refs.btnSetSearch.click()
				}
			},
			analizeCharacters(str) {
				switch (str.toUpperCase()) {
					default:
						this.getAllCoincidences(str)
						break
				}
			},
			actionSaveProductLocal(data) {
				this.searchId = data.id
			},
			actionSelectItemProductLocal(item) {
				this.showProductLocal(item.id)
			},
			actionSelectItemShippingRequestLocal(item) {
				console.log(item)
			},
			analizeResultSearch(data) {
				if(data != null) {
					switch (data.result) {
						case 'CHARACTER':
							this.analizeCharacters(data.data)
							break
						case 'PRODUCT':
						case 'ISBN':
							this.showProductLocal(data.data)
							break
						case 'SHIPPINGREQUEST':
							this.showShippingRequestLocal(parseInt(data.data))
							break
						case 'STORERACKSIDEROWCOLUMN':
							this.showStoreRackSideRowColumnLocal(parseInt(data.data))
							break
						default:
							console.log('No hay nada desarrollado para esto', data)
							break
					}
				}
			},
			getAllCoincidences(str) {
				this.sendMessageSocketPHP(str)
				this.currentsAction = []
				this.getAllProductsLocal(str)
				this.getAllShippingsRequestLocal(str)
			},
			getAllProductsLocal(str) {
				this.search = str
				this.currentsAction.push('LISTPRODUCT')
				setTimeout(() => {this.$refs.listProductsComponent.$refs.btnGetAllProductsLocal.click()}, 200)
			},
			getAllShippingsRequestLocal(str) {
				this.search = str
				this.currentsAction.push('LISTSHIPPINGSREQUEST')
				setTimeout(() => {this.$refs.listShippingsRequestComponent.$refs.btnExternalGetShippingsRequest.click()}, 200)
			},
			getCommandsByTypeLocal() {
				this.message = 'Estamos cargando los comandos del modulo. . .'
				this.getCommandsByType([2])
			},
			getCommandsByTypeResultLocal(response) {
				if(response.data.success == true) {
					this.setCommandModule(response.data.data)
					console.log('Se recuperó con exito los commandos del modulo!!!')
				}
			},
			existCurrentsAction(action) {
				let index = this.currentsAction.map(el => el).indexOf(action.toUpperCase())
				return index > -1
			},
			removeCurrentsAction(action) {
				let index = this.currentsAction.map(el => el).indexOf(action.toUpperCase())
				if(index > -1) {
					return this.currentsAction.splice(index,1)
				}
				return null
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			setInitModule() {
				this.search = ''
				this.currentsAction = []
				this.searchId = 0
				this.showCardLocal = false
				setTimeout(() => {
					this.$refs.inputSearchIntelligentComponentGeneral.$refs.btnSetSearch.click()
					this.$refs.inputSearchIntelligentComponentGeneral.$refs.btnSetFocus.click()
				}, 200)
			},
			showConfigGeneralLocal() {
				this.$emit('showConfigGeneral')
			},
			showConfigModuleLocal() {
				this.$refs.btnConfigModuleModal.click()
			},
			showManifestosLocal() {
				this.currentsAction = []
				this.currentsAction.push('LISTMANIFESTOS')
				setTimeout(() => { this.$refs.listManifestosComponent.$refs.btnGetManifestos.click()}, 200)
			},
			showPrinterLegalDocumentLocal(search) {
				this.$refs.printerLegalDocumentComponent.$refs.btnSetInitComponentDefault.click()
				this.dataPrinterLegalDocumentComponent.typeLegalDocumentID = 0
				this.dataPrinterLegalDocumentComponent.legalDocumentNumber = ''
				this.dataPrinterLegalDocumentComponent.quantity = 1
				this.currentsAction = []
				this.currentsAction.push('PRINTERLEGALDOCUMENT')
				if(search != null) {
					let searchArr = search.split(' ')
					switch (searchArr[0].toUpperCase()) {
						case 'BOLETA':
						case 'BOL':
							this.dataPrinterLegalDocumentComponent.typeLegalDocumentID = 39
							break
						case 'FACTURA':
						case 'FAC':
							this.dataPrinterLegalDocumentComponent.typeLegalDocumentID = 33
							break
						case 'GUIA':
							this.dataPrinterLegalDocumentComponent.typeLegalDocumentID = 52
							break
						case 'NOTA DE CREDITO':
						case 'NC':
							this.dataPrinterLegalDocumentComponent.typeLegalDocumentID = 61
							break
						case 'NOTA DE DEBITO':
						case 'ND':
							this.dataPrinterLegalDocumentComponent.typeLegalDocumentID = 56
							break
						default:
							break
					}

					if(searchArr.length > 1) {
						if(this.isInt(searchArr[1])) {
							this.dataPrinterLegalDocumentComponent.legalDocumentNumber = searchArr[1]
						}
					}

					if(searchArr.length > 2) {
						if(this.isInt(searchArr[2])) {
							this.dataPrinterLegalDocumentComponent.quantity = searchArr[2]
						}
					}

					setTimeout(() => { this.$refs.printerLegalDocumentComponent.$refs.btnSetInitComponentParent.click() }, 100)
					this.$refs.printerLegalDocumentComponent.$refs.btnSetInitComponentParent.click()
					if(this.dataPrinterLegalDocumentComponent.typeLegalDocumentID > 0 && this.dataPrinterLegalDocumentComponent.legalDocumentNumber != '') {
						setTimeout(() => { this.$refs.printerLegalDocumentComponent.$refs.btnSetInitComponentParent.click() }, 200)
						setTimeout(() => { this.$refs.printerLegalDocumentComponent.$refs.btnPrinter.click() }, 300)
					}

				}
			},
			showProductLocal(id, autoSearchProduct = true) {
				this.showCardLocal = true
				this.currentsAction = []
				this.currentsAction.push('PRODUCT')
				this.searchId = id
				this.autoSearchProduct = autoSearchProduct
				setTimeout(() => {this.$refs.productComponent.$refs.btnGetProduct.click()}, 200)
			},
			showShippingRequestLocal(id) {
				this.showCardLocal = true
				this.currentsAction = []
				this.currentsAction.push('SHIPPINGREQUEST')
				this.searchId = id
				setTimeout(() => {this.$refs.shippingRequestComponent.$refs.btnGetShippingRequest.click()}, 200)
			},
			showStoresLocal(search) {
				this.currentsAction = []
				this.currentsAction.push('LISTSTORES')
				setTimeout(() => { this.$refs.listStoresComponent.$refs.btnGetStores.click()}, 200)
				console.log('Listar Bodegas', search)
			},
			showStoreRackSideRowColumnLocal(id) {
				this.currentsAction = []
				this.currentsAction.push('STORERACKSIDEROWCOLUMN')
				this.searchId = id
				setTimeout(() => {this.$refs.columnComponent.$refs.btnShowStoreRackSideRowColumn.click()}, 100)
			},
			escucha(en) {
				console.log(en)
			}
		},
		mounted () {
			this.initModule()
		}
	}
</script>

<style scoped lang="scss">
</style>